var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpedia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1016.5 287.7",
    width: 2500,
    height: 708,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#072f54}.st1{fill:#fbc108}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path4354",
    className: "st0",
    d: "M488.6 225.1H457c-.2 0-.2 0-.3-.1l-27.2-33.2-27.2 33.2c-.1.1-.2.1-.3.1h-25.3c-.2 0-.3-.1-.4-.2 0-.1 0-.3.1-.4l40.1-49.2-39.6-48.7c-.1-.2-.1-.3-.1-.5.1-.1.2-.2.3-.2h31.6c.1 0 .2.1.3.2l23.9 29.6 24.3-29.6c.1-.1.2-.2.3-.2h25.7c.1 0 .3.1.4.2.1.2 0 .3-.1.5L446 171.7l43 52.8c.1.1.1.3.1.4-.2.2-.3.2-.5.2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path4358",
    className: "st0",
    d: "M659.5 143.3c-14 0-23.5 8.5-26.3 23.2h47.6v-1c0-11.7-8.7-22.2-21.3-22.2m45.8 38.4c-.1.1-.2.2-.3.2h-72.3c1.5 16.8 12.4 26.4 30.1 26.4 10.9 0 22.5-3.7 38.8-12.4.3-.2.6.1.6.4v22.2c0 .2-.1.3-.2.3-15.2 6.4-30.5 10.8-42.5 10.8-31.1 0-53.7-22.7-53.7-53.9s22.6-53.9 53.7-53.9c28.4 0 46.6 19.1 46.6 45.4 0 4.3-.7 14.2-.8 14.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path4362",
    className: "st0",
    d: "M852.1 105.3c-8.9 0-16.1-7.1-16.1-15.8 0-9 7.2-16.3 16.1-16.3 8.9 0 16.1 7.3 16.1 16.3 0 8.7-7.2 15.8-16.1 15.8m-13 119.8c-.3 0-.4-.1-.4-.4v-98.5c0-.2.1-.4.3-.4h26.1c.2 0 .3.2.3.4v98.5c0 .3-.2.4-.4.4h-25.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "path4366",
    className: "st0",
    d: "M536.4 210.3c-4.7 0-9.5-.7-15.1-2.1l.1-63.2c6.5-2.1 12.1-3 17.7-3 18.1 0 30.2 13.3 30.2 33.2 0 21.3-12.9 35.1-32.9 35.1m7.1-88.5c-7.4 0-14.8 1.3-22.6 4h-26c-.2 0-.4.2-.4.4v161.5c7.8-1.1 17.4-3.9 26.8-10.5v-49.1c6.4.9 11.7 1.5 16.8 1.5 35.6 0 58.6-21.3 58.6-54.3 0-31.5-21.9-53.5-53.2-53.5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "path4370",
    className: "st0",
    d: "M791.6 202.1c-8.1 4.3-15.4 6.3-22.2 6.3-16.1 0-25.8-11.4-25.8-30.5 0-22 12.3-36.3 31.4-36.3 5.3 0 10.4 1.3 16.6 4.1v56.4zm0-128.4v51.5c-7.6-2.2-14.3-3.2-21.1-3.2-31 0-54.3 23.3-54.3 54.3 0 30.8 20.6 53.2 49 53.2 9.8 0 19-2.5 29.8-8v8.9c7.1-1.4 15.3-4.2 23.4-10V63.1c-7.9 1.1-17.3 3.8-26.8 10.6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "path4374",
    className: "st0",
    d: "M955.9 201.9c-7.9 4.5-14.6 6.7-20.6 6.7-17.3 0-27.6-11.4-27.6-30.5 0-21.7 12.2-36.3 30.3-36.3 4.8 0 10.7 1.9 17.9 5.7v54.4zm26.8-77.3c0-.6-.5-1.1-1.1-1.1h-21.1c-.6 0-1.2.5-1.2 1.1v3.6h-.5c-9.7-4.3-18.1-6.2-26.2-6.2-29.2 0-52.1 24.2-52.1 55.2 0 31.3 20.5 52.3 51 52.3 8.1 0 18.6-.6 28.4-11.8v12.7c6.9-1.5 15.1-4.4 22.8-10v-95.8z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "path4378",
    className: "st0",
    d: "M304.5 200.5H370c-1 7.3-3.5 15.9-9.1 24.6H292.8c-8.3 0-15.2-6.5-16-14.6 0-.1-.1-.2-.1-.4V80.9c0-.1.1-.2.1-.3.8-8.2 7.7-14.7 16-14.7H369.9c-1 7.3-3.5 16.1-9.2 24.8h-56.2v35.2h55.7c.2 0 .4.2.4.4v24.4c0 .2-.2.4-.4.4h-55.7v49.4z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "path4382",
    className: "st0",
    d: "M222.5 227.2c-6.5 0-10.5-5.1-10.5-11.3 0-6.6 4.6-11.3 10.5-11.3 5.8 0 10.4 4.6 10.4 11.3s-4.6 11.3-10.4 11.3m0-23.8c-6.6 0-12.3 5-12.3 12.5 0 7.1 5.1 12.5 12.3 12.5 6.5 0 12.2-5 12.2-12.5s-5.6-12.5-12.2-12.5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "path4386",
    className: "st0",
    d: "M219.6 214.9v-4.6h3.1c1.6 0 3.4.2 3.4 2.1 0 2.3-1.7 2.4-3.6 2.4-.1.1-2.9.1-2.9.1zm8.7-2.2c0-3-1.8-4.3-5.4-4.3h-5.6v14.8h2.4v-6.3h2.3l3.8 6.3h2.8l-4.1-6.5c2.2-.2 3.8-1.3 3.8-4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "path4390",
    className: "st0",
    d: "M1004.3 142.2c-6.5 0-10.5-5.1-10.5-11.3 0-6.6 4.6-11.3 10.5-11.3 5.8 0 10.4 4.6 10.4 11.3 0 6.7-4.6 11.3-10.4 11.3m0-23.7c-6.6 0-12.3 5-12.3 12.5 0 7.1 5.1 12.5 12.3 12.5 6.5 0 12.2-5 12.2-12.5 0-7.6-5.7-12.5-12.2-12.5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "path4394",
    className: "st0",
    d: "M1001.3 129.9v-4.5h3.1c1.6 0 3.4.2 3.4 2.1 0 2.3-1.7 2.4-3.6 2.4h-2.9zm8.8-2.1c0-3-1.8-4.3-5.4-4.3h-5.6v14.8h2.4V132h2.3l3.8 6.3h2.8l-4.1-6.5c2.1-.2 3.8-1.3 3.8-4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "path4398",
    className: "st0",
    d: "M138 90.6l-4.7-13.4-40.4-53.9 7.2-1.8 69.5 60.1 40.9-11.7c4.8-1.2 10.3-1.5 14.4-1.5-12.8-27.7-36.4-50.5-67.4-61.5C96.2-15 28.7 17.1 6.9 78.5c-6.8 19-8.3 38.6-5.5 57.2l97.9-34L138 90.6z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "path4402",
    className: "st0",
    d: "M229.3 79c-3.6 2.3-8.9 5.4-14.1 7.1l-41 11.7-27.3 87.8-7.1 2.3 5.8-67-3.2-13.9-38.4 11L2.4 141.7c8.1 39 35.7 73.1 76 87.4 61.4 21.9 128.8-10.2 150.7-71.6 9.4-26.3 8.8-53.9.2-78.5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "path4406",
    className: "st1",
    d: "M142.3 106.9l3.2 13.9-5.8 67 7.1-2.3 27.3-87.8 41-11.7c5.2-1.7 10.5-4.7 14.1-7.1-1.3-3.6-2.7-7.1-4.3-10.6-4.2 0-9.6.2-14.4 1.5l-40.9 11.7-69.5-60.1-7.2 1.8 40.3 53.9 4.7 13.4-38.7 11.1-97.9 34c.3 2 .7 4.1 1.1 6.1l101.5-23.9 38.4-10.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpedia);
export default __webpack_public_path__ + "static/media/expedia.b6bee3f5e5f2b58483ce3910d5a1067c.svg";
export { ForwardRef as ReactComponent };